import request from '@/utils/request';
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
// 资产
export function getPropertyInfo(data) {
  return request({
    url: `${API}v2/personalData/getPropertyInfo`,
    method: "get"
  });
}

// 邮件
export function getEmailData(data) {
  return request({
    url: `${API}v2/personalData/getEmailData`,
    method: "get"
  });
}

// 获取图书信息
export function getMyBooks(data) {
  return request({
    url: `${API}v2/personalData/getMyBooks`,
    method: "get"
  });
}

// 获取一卡通信息
export function getMyECard(data) {
  return request({
    url: `${API}v2/personalData/getMyECard`,
    method: "get"
  });
}

// 获取论文信息
export function getPaper(data) {
  return request({
    url: `${API}v2/personalData/getPaper`,
    method: "get"
  });
}

// 获取科研信息
export function getScientificResearch(data) {
  return request({
    url: `${API}v2/personalData/getScientificResearch`,
    method: "get"
  });
}
// 获取工资信息
export function getSalaryData(data) {
  return request({
    url: `${API}v2/personalData/getSalaryData`,
    method: "get"
  });
}
// 获取网费信息
export function getNetworkFeeInfo(data) {
  return request({
    url: `${API}v2/personalData/getNetworkFeeInfo`,
    method: "get"
  });
}
// 获取上网账号
export function getNetworkAccount() {
  return request({
    url: `${API}portalCenter/api/rest/center/personalData/search`,
    method: "get"
  });
}
// 注册网络账号
export function addNetworkAccount(params) {
  return request({
    url: `${API}portalCenter/api/rest/center/personalData/addUser?pwd=${params.pwd}`,
    method: "POST",
    data: params
  });
}
// 注册邮箱
export function registerEmailBox(params) {
  return request({
    url: `${API}portalCenter/api/rest/center/personalData/api/userData/registerEmailBox`,
    method: "POST",
    data: params
  });
}
// 邮箱后缀
export function getMailSuffix() {
  return request({
    url: `${API}portalCenter/api/rest/center/personalData/api/userData/getMailSuffix`,
    method: "get"
  });
}